import { Route } from '@/router/types'

export const pathwayAdminRoutes: Route[] = [
  {
    path: '/admin/playbooks/subtasks',
    name: '#adminSubtasks',
    component: () =>
      import('@/legacy/components/admin/playbooks/AdminSubtasksTable.vue'),
    meta: {
      title: 'Admin Subtasks',
      permissionCheck: 'canViewPathwaysAdmin',
    },
  },
  {
    path: '/admin/playbooks/subtasks/:baseTemplateId',
    name: '#adminEditSubtasks',
    component: () =>
      import(
        '@/legacy/pages/pathwaysAdmin/AdminEditSubtasksTemplate/AdminEditSubtasksTemplate.vue'
      ),
    meta: {
      title: 'Admin Edit Subtask Template',
      permissionCheck: 'canViewPathwaysAdmin',
    },
  },

  {
    path: '/admin/playbooks/tasks',
    name: '#adminTasks',
    component: () =>
      import('@/legacy/components/admin/playbooks/AdminTasksTable.vue'),
    meta: {
      title: 'Admin Tasks',
      permissionCheck: 'canViewPathwaysAdmin',
    },
  },
  {
    path: '/admin/playbooks/tasks/:baseTemplateId',
    name: '#adminEditTasks',
    component: () =>
      import(
        '@/legacy/pages/pathwaysAdmin/AdminEditTasksTemplate/AdminEditTasksTemplate.vue'
      ),
    meta: {
      title: 'Admin Edit Task Template',
      permissionCheck: 'canViewPathwaysAdmin',
    },
  },

  {
    path: '/admin/playbooks/playbooks',
    name: '#adminPlaybooks',
    component: () =>
      import('@/legacy/components/admin/playbooks/AdminPathwaysTable.vue'),
    meta: {
      title: 'Admin Playbooks',
      permissionCheck: 'canViewPathwaysAdmin',
    },
  },
  {
    path: '/admin/playbooks/playbooks/:baseTemplateId',
    name: '#adminEditPlaybooks',
    component: () =>
      import(
        '@/legacy/pages/pathwaysAdmin/AdminEditPathwaysTemplate/AdminEditPathwaysTemplate.vue'
      ),
    meta: {
      title: 'Admin Edit Pathway Template',
      permissionCheck: 'canViewPathwaysAdmin',
    },
  },
  {
    path: '/admin/triggers',
    name: '#adminTriggers',
    component: () =>
      import('@/legacy/components/admin/triggers/AdminTriggers.vue'),
    meta: {
      title: 'Admin Autotriggers',
      permissionCheck: 'canReadTriggerOutcomes',
    },
  },
  {
    path: '/admin/csv',
    name: '#adminCsvUploads',
    component: () => import('@/legacy/components/admin/AdminCSVUploads.vue'),
    meta: {
      title: 'Admin CSV Uploads',
      permissionCheck: 'canViewPathwaysAdmin',
    },
  },
]
